var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"spinner-holder"},[_c('div',{staticClass:"spinner-wrapper",style:({
			width: `${_vm.boxSize}px`,
			minWidth: `${_vm.boxSize}px`,
			maxWidth: `${_vm.boxSize}px`,
			height: `${_vm.boxSize}px`,
			minHeight: `${_vm.boxSize}px`,
			maxHeight: `${_vm.boxSize}px`,
		})},[_c('svg',{staticClass:"spinner-percent",attrs:{"viewBox":"0 0 50 50","width":_vm.boxSize,"height":_vm.boxSize}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","stroke-dasharray":_vm.fillMax,"stroke-dashoffset":_vm.fillValue,"stroke":_vm.color,"fill":"none","stroke-width":_vm.width}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }